import React, { useState, useEffect } from 'react';
import { uploadFile, getProjects } from '../api';
import LoadingSpinner from './LoadingSpinner';
import { ErrorState, EmptyState } from './shared/UIComponents';
//NOTE: PULL CHANGES FROM MAIN BRANCH BEFORE DEVELOPING
function UploadFile({ onDataReceived }) {
  const [previewRows, setPreviewRows] = useState([]);
  const [fileType, setFileType] = useState('Proteinomics');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  //Fore new requirements button
  const [isOpen, setIsOpen] = useState(false);

  // Projects state
  const [existingProjects, setExistingProjects] = useState([]); // Fetched from DB
  const [selectedProjectId, setSelectedProjectId] = useState('new'); // Dropdown value
  const [newProjectName, setNewProjectName] = useState(''); // Text input value

  //State for checkbox 
  // 1. Initialize the state (defaults to unchecked/false)
  const [preprocessing_applied, setIsChecked] = useState(false);

  // 2. Handle the change event when the user clicks the checkbox
  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
  };


  // 1. Fetch existing projects when component mounts for the dropdown
  useEffect(() => {
    const loadProjects = async () => {
      try {
        const response = await getProjects();
        
        if (response && response.projects) {
          setExistingProjects(response.projects);
        }
      } catch (err) {
        console.error("Failed to load projects:", err);
      }
    };

    loadProjects();
  }, []);

  // Toggle Modal handlers
  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);
  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setError(null);
    setSuccess(null);
  };


  // Upload the selected file - NOTE: we now upload the file type as well
  const handleUpload = async () => {
    if (!file) {
      setError('Please select a file to upload.');
      return;
    }
    setLoading(true);
    setError(null);
    setSuccess(null);
    try {
      if (!file) return;
      // Decide project name (either existing selection or new name)
      const projectName = selectedProjectId === 'new' ? newProjectName : selectedProjectId;
      
      const data = await uploadFile(file, fileType, projectName, preprocessing_applied);
      const name = data.dataset_name || (file.name && file.name.replace(/\.[^.]+$/, ''));
      setPreviewRows(data.preview || []);

      // Update the dataset list
      const updatedProjects = await getProjects();
      if (updatedProjects && updatedProjects.projects) {
        setExistingProjects(updatedProjects.projects);
      }

      //what does the dataset list look like
      console.log("Dataset List:", updatedProjects);

      setSuccess(data.message || `Dataset "${name}" uploaded successfully.`);
      onDataReceived && onDataReceived(data);
      setTimeout(() => setSuccess(null), 6000);
    } catch (err) {
      setError(err.message || 'Failed to upload file. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleFileTypeChange = (event) => {
    setFileType(event.target.value);
  };

  return (
    
    <div className="upload-file">
     <form onSubmit={handleUpload}>
      {/* File Inputs Here ... */}

      {/* Project Selection Container */}
      <div className="create-project__container" style={{ marginTop: "20px", marginBottom: "20px" }}>
        <h3 className="create-project__title">Select project</h3>
        <p style={{ fontSize: '0.65rem', fontWeight: 'bold' }} className="create-project__text">
          Select the project you would like to upload the dataset to:
        </p>

        {/* Bound Dropdown */}
        <select 
          className="create-project__select"
          value={selectedProjectId}
          onChange={(e) => setSelectedProjectId(e.target.value)}
        > 
          <option value="new">+ Create New Project</option>
          {existingProjects.map((projName) => {
            if (projName !== 'Demo') {  // Exclude the demo dataset from the dropdown
              return (
                <option key={projName} value={projName}>
                  {projName}
                </option>
              );
            }
            return null;
          })}
        </select>

        {/* Conditionally show text input ONLY when 'new' is selected */}
        {selectedProjectId === 'new' && (
          <input
            type="text"
            value={newProjectName}
            onChange={(e) => setNewProjectName(e.target.value)}
            placeholder="New project name"
            style={{
              width: '150px',
              padding: '4px 8px',
              fontSize: '12px',
              height: '24px',
              marginLeft: '10px'
            }}
          />
        )}
      </div>
    </form>

      <h3 className="upload-file__title">Upload File</h3>
      <label className="file-type__label" style = {{fontSize: '0.95rem', fontWeight: 'bold'}}>File* </label>
        <input 
        type="file" 
        onChange={handleFileChange}
        disabled={loading}
        className="upload-file__input"
      />
      <label className="file-type__label" style = {{fontSize: '0.95rem', fontWeight: 'bold'}}>File Type* </label> 
      <>
      {/* 1. The Trigger Button (styled exactly like yours) */}
      <button 
        onClick={openModal}
        style={{ 
          width: '110px', 
          padding: '6px 10px', 
          fontSize: '0.65rem', 
          backgroundColor: 'red',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          fontWeight: 'bold'
        }}
      >
        Requirements
      </button>

      {/* 2. The Modal Overlay (Only renders when isOpen is true) */}
      {isOpen && (
        <div 
          onClick={closeModal} // Closes modal if user clicks the dimmed background
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.6)', // Dims the background
            backdropFilter: 'blur(3px)', // Subtle blur effect for depth
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000, // Makes sure it sits on top of everything
          }}
        >
          {/* 3. The Modal Card */}
          <div 
            onClick={(e) => e.stopPropagation()} // Prevents closing when clicking inside the card
            style={{
              backgroundColor: 'white',
              width: '90%',
              maxWidth: '550px', // Big enough to read, small enough to see the background
              borderRadius: '12px',
              padding: '30px',
              boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.3)',
              fontFamily: 'sans-serif',
              color: '#333',
              position: 'relative',
            }}
          >
            

            {/* Modal Content */}
            <h2 style={{ marginTop: 0, color: '#111', fontSize: '1.5rem' }}>
              Dataset Upload Requirements
            </h2>
            <h4 style={{ marginTop: 0, color: '#111', fontSize: '1.2rem' }}>
              General Guidelines
            </h4>
            <p style={{ color: '#666', fontSize: '0.9rem', lineHeight: '1.5' }}>
              To ensure your file processes correctly, please verify that it meets the following structural rules before uploading:
            </p>

            <hr style={{ border: '0', borderTop: '1px solid #eee', margin: '20px 0' }} />

            <ul style={{ paddingLeft: '20px', fontSize: '0.9rem', lineHeight: '1.6' }}>
              <li><strong>File Type:</strong> Must be a valid <code>.csv</code> or <code>.xlsx</code> file.</li>
              <li><strong>First Row:</strong> Must contain clear, non-empty column headers.</li>
              <li><strong>File Size:</strong> Must be under 50MB.</li>
              <li><strong>Column Names:</strong> Required Column names by any specific file type are CASE SENSITIVE.</li>
              <li><strong>Character Encoding:</strong> Saved in UTF-8 format to prevent corrupt text.</li>
            </ul>

            <h4 style={{ marginTop: 0, color: '#111', fontSize: '1.2rem' }}>
              Specific Requirements
            </h4>

            <p style={{ color: '#111', fontSize: '0.9rem', lineHeight: '0.5' }}>
              Bulk RNA-Seq:
            </p>
            <ul style={{ paddingLeft: '20px', fontSize: '0.9rem', lineHeight: '1.6' }}>
              <li><strong>First Column: geo_accession - </strong> Unique identifier for each sample.</li>
              <li><strong>Second Column: condition - </strong> Treatment or control group for each sample.</li>
            </ul>
            {/* Close Button at bottom */}
            <div style={{ textAlign: 'right', marginTop: '25px' }}>
              <button 
                onClick={closeModal}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#333',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  cursor: 'pointer',
                  fontSize: '0.85rem'
                }}
              >
                Got it, thanks!
              </button>
            </div>
          </div>
        </div>
      )}
    </>
      
        <select
          value={fileType} 
          onChange={e => handleFileTypeChange(e)}
          className="file-type__select"
        >
          <option value="proteomics">Proteomics</option>
          <option value="bulk">Bulk RNA-Seq</option>
          <option value="singlecell">scRNA-Seq</option>
        </select>
        <div style={{ padding: '20px' }}>
      <label htmlFor="preprocess-checkbox" style = {{fontSize: '0.75rem', fontWeight: 'bold'}}>
        <input
          type="checkbox"
          id="preprocess-checkbox"
          checked={preprocessing_applied} // Tied to state
          onChange={handleCheckboxChange} // Updates state
        />
        Preprocess data?
      </label>
      </div>
      <button 
        onClick={handleUpload} 
        disabled={!file || loading}
        className="upload-file__upload-btn"
      >
        {loading ? (
          <LoadingSpinner size="small" text="Uploading..." />
        ) : (
          'Upload'
        )}
      </button>
      
      {loading && (
        <div className="upload-file__loading">
          <LoadingSpinner text="Uploading file..." />
        </div>
      )}

      {!loading && !file && !error && (
        <EmptyState
          title="No file selected"
          description="Choose a CSV file, then click Upload to create a dataset."
          icon="📄"
        />
      )}
      
      {success && (
        <div className="upload-file__success" style={{ marginTop: 8, color: 'var(--success, #0a0)', fontSize: 14 }}>
          ✓ {success}
        </div>
      )}
      {error && (
        <ErrorState
          message={error}
          onRetry={file ? handleUpload : null}
        />
      )}
      
      {/* {previewRows.length > 0 && (
        <div style={{ marginTop: '1rem' }}>
          <h4>Preview (first 5 rows)</h4>
          <table border="1" style={{ width: '100%', fontSize: '12px' }}>
            <thead>
              <tr>
                {Object.keys(previewRows[0]).map((key) => (
                  <th key={key} style={{ padding: '4px', background: 'var(--primary)', color: 'var(--white)' }}>
                    {key}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {previewRows.map((row, idx) => (
                <tr key={idx}>
                  {Object.values(row).map((val, i) => (
                    <td key={i} style={{ padding: '4px', border: '1px solid var(--border)' }}>
                      {val}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )} */}
    </div>
  );
}
export default UploadFile;